import React from 'react';

import { cn } from '../../../utils/cn.js';

export default function PortalCardWrapper({ children, className }) {
  return (
    <div
      className={cn(
        'relative flex flex-col gap-10 rounded-[40px] bg-portal-background p-8 md:p-12 lg:p-16 xl:p-20',
        className,
      )}
    >
      {children}
    </div>
  );
}
